import { Link } from 'react-router'
import { Hash } from 'lucide-react'
import { cn } from '@/lib/utils'

type TagBadgeProps = {
  name: string
  color: string
  size?: 'sm' | 'md'
  active?: boolean
  to?: string
}

export function TagBadge({ name, color, size = 'md', active, to }: TagBadgeProps) {
  const badge = (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full',
        size === 'sm' ? 'gap-0.5 px-1.5 py-0 text-xs' : 'gap-1 px-2.5 py-0.5 text-xs',
        active
          ? 'bg-foreground text-background'
          : 'bg-muted text-foreground',
      )}
    >
      <Hash
        className={cn('shrink-0', size === 'sm' ? 'size-3' : 'size-3.5')}
        style={{ color: active ? undefined : color }}
      />
      {name}
    </span>
  )

  if (to) {
    return <Link to={to}>{badge}</Link>
  }

  return badge
}
